import { jsx as _jsx } from "react/jsx-runtime";
export const renderPlainLink = (attrs) => {
    return _jsx("a", { ...attrs, children: attrs.children });
};
//# sourceMappingURL=renderPlainLink.js.map